import ModalForm from 'components/commons/modal-form'
import UploadImage from 'components/commons/upload-image'
import { InlineError, Input } from 'avo-ui'
import Datepicker from 'components/commons/datepicker'
import RadioButton from 'components/commons/radio-button'
import moment from 'moment/moment'

export const FormProfile = ({ show, onHideForm, dataProfile, isLoading, onChangeForm, errorForm, onSubmit }) => {
    return (
        <ModalForm
            className={'!w-[450px]'}
            classNameContent={'!h-[500px] overflow-auto'}
            show={show}
            onHide={onHideForm}
            title={'Edit Profile'}
            isLoading={isLoading}
            onSubmit={onSubmit}
        >
            <div className={'flex flex-col space-y-6 px-8 py-2 mb-2'}>
                <UploadImage
                    classNameImage={'!w-28 !h-28 border-4 border-blue-20 rounded-full'}
                    classNameButtonDelete={'!-top-1 !-right-2'}
                    id={'image-profile'}
                    caption={'Foto Profile'}
                    value={dataProfile?.profile_picture?.base64 || dataProfile?.profile_picture}
                    onChange={(value) => onChangeForm({ name: 'profile_picture', value })}
                />
                <InlineError className='mt-2 self-center' message={errorForm?.profile_picture} />
                <div className={'flex flex-col space-y-3'}>
                    <div className={'font-semibold text-blue-90 required'}>Nama</div>
                    <Input
                        className={'flex-1'}
                        name={'name'}
                        placeholder={'Masukkan nama'}
                        maxLength={60}
                        value={dataProfile?.name}
                        onChange={onChangeForm}
                    />
                    <InlineError className='mt-2' message={errorForm?.name} />
                </div>
                <div className={'flex flex-col space-y-3'}>
                    <div className={'font-semibold text-blue-90 required'}>Email</div>
                    <Input
                        name={'email'}
                        className={'flex-1'}
                        value={dataProfile?.email}
                        onChange={onChangeForm}
                        placeholder={'Masukkan email'}
                    />
                    <InlineError className='mt-2' message={errorForm?.email} />
                </div>
                <div className={'flex flex-col space-y-3'}>
                    <div className={'font-semibold text-blue-90'}>Tanggal Lahir</div>
                    <Datepicker
                        value={dataProfile?.birth_date}
                        onChange={(value) => onChangeForm({ name: 'birth_date', value })}
                        format={'YYYY-MM-DD'}
                        maxDate={moment()}
                        isClearable
                    />
                    <InlineError className='mt-2' message={errorForm?.birth_date} />
                </div>
                <div className={'flex flex-col space-y-3'}>
                    <div className={'font-semibold text-blue-90'}>No. Telepon</div>
                    <Input
                        type={'tel'}
                        addonBefore={'+62'}
                        className={'flex-1'}
                        name={'phone_number'}
                        placeholder={'Masukkan no. telepon'}
                        maxLength={14}
                        value={dataProfile?.phone_number}
                        onChange={onChangeForm}
                    />
                    <InlineError className='mt-2' message={errorForm?.phone_number} />
                </div>
                <div className={'flex flex-col space-y-3'}>
                    <div className={'font-semibold text-blue-90'}>Jenis Kelamin</div>
                    <div className={'flex space-x-2'}>
                        <RadioButton
                            label={'Perempuan'}
                            name={'gender'}
                            value={'female'}
                            checked={dataProfile?.gender === 'female'}
                            onChange={onChangeForm}
                        />
                        <RadioButton
                            label={'Laki-Laki'}
                            name={'gender'}
                            value={'male'}
                            checked={dataProfile?.gender === 'male'}
                            onChange={onChangeForm}
                        />
                    </div>
                    <InlineError className='mt-2' message={errorForm?.gender} />
                </div>
            </div>
        </ModalForm>
    )
}
